import Search, { SearchInitConfig, SearchClientConfig} from "../search";
import Utility from '../../classes/utility';
import { MenuItem } from "instantsearch.js/es/connectors/menu/connectMenu";
import { ViewFilterType } from "../search";
import { SearchEventHitsRendered, SearchEventTypes } from "../utilities/search-events";
import SearchUtility from "../utilities/search-utility";

// Define FacetsRefinements interface for counting active filters
interface FacetsRefinements {
    [key: string]: string[];
}

interface PlaceholderAreaElements {
    placeholderTag: HTMLTitleElement;
    resultsContainer: HTMLElement;
}

class ConedSearch extends Search {
    resetSearch: boolean = false;
    
    constructor(clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
    }

    init() {
        super.init();

        // custom search for updating filter number on mobile button
        this.customSearch = function(helper) {
            let mobileFiltersButton = document.getElementById("mobile-filters-btn");
            if (mobileFiltersButton) {
                var filtersActiveCount: number = Object.values(this.search.helper.state.disjunctiveFacetsRefinements as FacetsRefinements)
                .reduce((acc: number, curr: Array<string>) => {
                    return acc + curr.length;
                }, 0);

                // if 0 display filters if not display filters (count)
                if (filtersActiveCount > 0) {
                    mobileFiltersButton.innerHTML = `Filters (${filtersActiveCount})`;
                } else {
                    mobileFiltersButton.innerHTML = `Filters`;
                }
            }
        };
        
        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);


        if (query) {
            this.search.helper.setQuery(query)
            this.search.helper.search();
        }
    }

    private onLoadSearch() {
        // get the algolia search box
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        if (searchBox) {
            this.init();
        }
    }

    private onLoadViewFilters() {
        // init view filters
        // search needs to be defined for the below to work
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        const DeliverylabelFn = function (item: MenuItem) {
            item.label = Utility.removeAfterHyphen(item.label);
            return item;
        };

        //Refactor the code since its used on both coned & programs & courses search 
        const AOILabelFn = (item: MenuItem): MenuItem => {
            item.label = SearchUtility.getAOILabel(item.label);
            return item;
        };

        this.addViewFilter({
            elementId:"filter-type",
            urlParam: "type",
            urlSpace: true,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-location",
            urlParam: "location",
            urlSpace: true,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId: "filter-aoi",
            urlParam: "areaofinterest",
            modFn: AOILabelFn,
            filterType: ViewFilterType.RefinementList,
            cssClasses : {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-available-international",
            urlParam: "international",
            urlSpace: true,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input toggle-checkbox",
                item: "form-check form-toggle"
            }
        });

        this.addViewFilter({
            elementId:"filter-prerequisites",
            urlParam: "prerequisites",
            urlSpace: true,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input toggle-checkbox",
                item: "form-check form-toggle"
            }
        });

        this.addViewFilter({
            elementId:"filter-newest",
            urlParam: "other",
            urlSpace: true,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check form-toggle"
            }
        });

        this.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${this.initConfig.searchBoxId}-clear-filters`
        });

        this.addViewFilter({
            filterType: ViewFilterType.SortBy,
            elementId: `${this.initConfig.searchBoxId}-sortby`
        });
    }

    private onLoadViewUpdates() {
        this.searchEvents.addListener(SearchEventTypes.HitsRendered, (eventData: SearchEventHitsRendered) => {
            // guard statement to deflect to no results
            if (eventData.count == 0) return;
            const pcResultCount = document.querySelector(".pc-result-search-count") as HTMLParagraphElement;
            if (pcResultCount) {
                pcResultCount.innerHTML = "Showing <strong>" + eventData.count + "</strong> results";
            }
        });
    }

    public viewAreas(headerTitleShow): PlaceholderAreaElements {
        const resultsContainer: HTMLElement = document.getElementById(this.initConfig.resultContainerId);
        const placeholderTag: HTMLTitleElement = document.querySelector(".pc-result-search-count");

        if (placeholderTag) {
            if (headerTitleShow) {
                placeholderTag.classList.remove("d-none");
            } else {
                placeholderTag.classList.add("d-none");
            }
        }
        return {
            placeholderTag: placeholderTag,
            resultsContainer: resultsContainer
        }
    }

    override onLoad(facets: Array<any>) {
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }
}
export default ConedSearch;